import { render, staticRenderFns } from "./message-expand-column.vue?vue&type=template&id=9262ae8a"
import script from "./message-expand-column.vue?vue&type=script&lang=js"
export * from "./message-expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9262ae8a')) {
      api.createRecord('9262ae8a', component.options)
    } else {
      api.reload('9262ae8a', component.options)
    }
    module.hot.accept("./message-expand-column.vue?vue&type=template&id=9262ae8a", function () {
      api.rerender('9262ae8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/message-expand-column.vue"
export default component.exports